import { Fragment, useContext } from 'react'
import Svg from '../Svg/Svg'

import { FilterContext } from '../../context/FilterContext'

const FilterOverlay = (props) => {
  const { closeOverlay, filters } = props

  // Filter context
  const FilterContextState = useContext(FilterContext)

  // Save accordions data in array to loop over on render
  let accordions = []
  accordions.push(filters.types)
  accordions.push(filters.status)
  accordions.push(filters.regions)

  const triggerSelection = (e) => {
    FilterContextState.selectFilter(e.target.dataset)
    closeOverlay()
  }

  const FilterAccordions = accordions.map((accordion, index) => {
    return (
      <div key={`Filter-accordion-${index}`}
           className={`Filter-accordion${FilterContextState.openFilterAccordion === index ? ` is-open` : ``}`}>
        <div className={`Filter-accordionHead`}
             onClick={() => FilterContextState.setOpenFilterAccordion(index)}>
          <span>{accordion.label}</span>
          <Svg id={`icon-plus`} modifier={`Filter-accordionSvg`}/>
        </div>
        <ul className={`Filter-accordionItems${accordion.items.length >= 10 ? ` is-columns` : ``}`}>
          {accordion.items.map((item, index) => {
            return (
              <li key={`Filter-accordionItem-${index}`}
                  data-category={accordion.type}
                  data-title={item.title} data-id={item.id}
                  onClick={(e) => triggerSelection(e)}
                  className={`Filter-accordionItem`}>{item.title}</li>
            )
          })}
        </ul>
      </div>
    )
  })

  return (
    <Fragment>
      <div className={`Filter-submenu`}>
        <div className={`Filter-submenuInner`}>
          <div className={`Filter-submenuHead`}>
            <button className={`Filter-close`} onClick={() => {closeOverlay()}}>
              <Svg id={`icon-close`} modifier={`Filter-closeSvg`}/>
            </button>
          </div>
          <div className={`Filter-submenuContent`}>
            <div className={`Filter-submenuContentInner`}>
              { FilterAccordions }
            </div>
          </div>
        </div>
      </div>
      <div className={`Filter-overlay`} onClick={() => closeOverlay()}/>
    </Fragment>
  )
}

export default FilterOverlay
